<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>助力活动</div>
		<div class="title">
			<div class="left">
				<router-link to="/newHelpActive"><el-button type="primary" size="small">创建活动</el-button></router-link>
			</div>
			<div class="right">
				<el-select v-model="activeState" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" placeholder="请输入团长名字" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small">筛选</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="exchangeCodeList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="name1" align="center" label="活动名称"></el-table-column>
				<el-table-column label="助力人数" prop="name2" align="center" width="200"></el-table-column>
				<el-table-column prop="name3" align="center" label="活动商品"></el-table-column>
				<el-table-column align="center" label="拼团活动时间" width="200">
					<template slot-scope="scope">
						<p>起：{{scope.row.name4}}</p>
						<p>止：{{scope.row.name5}}</p>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name6" label="总团数"></el-table-column>
				<el-table-column align="center" label="状态">
					<template slot-scope="scope">
						{{scope.row.name7==1?'进行中':'已失效'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="250">
					<template slot-scope="scope">
						<el-button type="text" @click="dialog_tuig = true">分享</el-button>
						<el-button type="text">编辑</el-button>
						<el-button type="text">停止助力</el-button>
						<el-button type="text">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background style="margin-top: 30px;" layout="prev, pager, next" :page-size="10" :total="80">
			</el-pagination>
		</div>
		<!-- 推广 -->
		<el-dialog :visible.sync="dialog_tuig" width="25%">
			<div class="dia_title">优惠券H5</div>
			<div class="erwei">
				<img src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393" />
			</div>
			<div>
				<div class="downerwei" @click="downloadCodeImg(img)">
					下载二维码
				</div>
			</div>
			<section class="form">
				<el-input :disabled="true" size="small" v-model="cjurl" style="width: 252px;margin-left:50px;margin-top: 20px;
					 margin-bottom:30px;"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-clipboard:copy="cjurl" v-clipboard:success="onCopy"
						v-clipboard:error="onError" @click="dialog_tuig = copy">复 制</el-button>
				</span>
			</section>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeState: "全部活动",
				activeStateList: [],
				activeTime: "",
				exchangeCodeList: [{
					name1: "活动七天乐活动",
					name2: 12,
					name3: '剪发5元券',
					name4: "2020-08-17 20:00",
					name5: "2020-08-18 20:00",
					name6: 7,
					name7: 1
				}],
				deleteAd: false,
				dialog_tuig: false,
				cjurl: "",
			}
		},
		methods: {
			//复制路劲
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
				this.snackBar.info(this.$t('prompt.copySuccess'))
			},
			onError() {
				this.$message.error(this.$t('prompt.copyFail'))
			},
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>